
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/earthquake-early-warning/dsclaimer",
      function () {
        return require("private-next-pages/earthquake-early-warning/dsclaimer.tsx");
      }
    ]);
  